import React, { useState } from 'react'; // Importe useState
import { motion } from 'framer-motion';
import { FaBug, FaPhone, FaExclamationTriangle } from 'react-icons/fa';
import '../../../assets/css/descupinizacao.css';

const Descupinizacao = () => {
    // Estado para controlar a expansão/encurtamento do texto
    const [isTextExpanded, setIsTextExpanded] = useState(false);

    // Mantenha os textos originais, não os altere
    const paragraph1 = `Os cupins ou brocas podem causar danos devastadores à madeira, afetando não apenas a estética, mas também a qualidade do som do seu piano, pois o material e o ambiente escuro em seu interior oferecem as condições necessárias para sua proliferação.`;
    const paragraph2 = `Por se tratar de um instrumento complexo com diversos pequenos componentes e muitos deles metálicos, a descupinização praticada por dedetizadoras convencionais não se aplica em pianos, pois não são capazes de penetrar nas entranhas da madeira e acessar os focos.`;
    const paragraph3 = `<span class="descupinizacao-highlight">Dominamos a única técnica realmente eficaz</span> desenvolvida exclusivamente para pianos. Entre em contato e solicite um orçamento para descupinização.`;


    return (
        <div className="descupinizacao-container">
            {/* Seção de Texto (Lado Esquerdo) */}
            <motion.div
                className="descupinizacao-text"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h2 className="descupinizacao-title">
                    <FaBug className="feature-icon" /> Descupinização Especializada
                </h2>

                {/* NOVO: Wrapper para os textos controlados pelo "Leia Mais" */}
                <div className={`text-container-mobile ${isTextExpanded ? 'expanded' : ''}`}>
                    <motion.p
                        className="descupinizacao-content animate-fade-in"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.2 }}
                    >
                        {paragraph1}
                    </motion.p>

                    <motion.p
                        className="descupinizacao-content animate-fade-in"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.4 }}
                    >
                        <FaExclamationTriangle className="feature-icon" /> {paragraph2}
                    </motion.p>

                    <motion.p
                        className="descupinizacao-content animate-fade-in"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.6 }}
                        // Usando dangerouslySetInnerHTML para renderizar o span com highlight
                        dangerouslySetInnerHTML={{ __html: paragraph3 }}
                    >
                    </motion.p>
                </div>

                {/* NOVO: Botão "Leia Mais/Ver Menos" visível SOMENTE no celular */}
                <button
                    className="read-more-button"
                    onClick={() => setIsTextExpanded(!isTextExpanded)}
                >
                    {isTextExpanded ? 'Ver Menos' : 'Leia Mais'}
                </button>

                <motion.div
                    className="descupinizacao-cta animate-fade-in"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8 }}
                >
                    <button className="cta-button">
                        <FaPhone /> Solicitar Orçamento
                    </button>
                </motion.div>
            </motion.div>

            {/* Seção de Imagem (Lado Direito) */}
            <motion.div
                className="descupinizacao-image"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
            >
                <img
                    src="/img/selo.webp" // Certifique-se de que esta imagem existe em public/img/
                    alt="Danos de cupins em piano"
                    loading="lazy"
                />
            </motion.div>
        </div>
    );
};

export default Descupinizacao;